<template>
  <fh-container justify-center>
    <fh-card justify-center>
      <v-card-title primary-title class="grey lighten-3">
        <h3 class="headline">Elegir Agricultor</h3>
      </v-card-title>
      <v-card-text class="px-0">
        <v-text-field
            v-if="showSearchField"
            v-model="search"
            append-icon="fa-search"
            label="Buscar"
            single-line
            hide-details
            autofocus
            @click.stop=""
            class="pb-4"
        ></v-text-field>
        <v-list>
          <template v-for="(agricultor,i) in searchFilteredAgricultorList">
            <!-- Agricultor con mas de un establecimiento -->
            <v-list-group
              v-if="agricultor.establecimientoList.length > 1"
              no-action
              :key="agricultor.agricultor.nombre"
              class="mb-0"
            >
              <template v-slot:activator>
                <v-list-item-icon class="mr-2"><v-icon small>fa-user</v-icon></v-list-item-icon>
                <v-list-item-content @click="expandList(i)">
                  <v-list-item-title>{{agricultor.agricultor.nombre}}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item-group>
                <template
                  v-for="(establecimiento,e) in agricultor.establecimientoList"
                >
                <v-list-item
                  class="mb-0"
                  :key="`${establecimiento.idEstablecimiento}${e}`"
                  @click="handleElegirAgricultor(agricultor.agricultor.idAgricultor,establecimiento)"
                >
                  <v-list-item-icon class="mr-2"></v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="hidden-sm-and-down">
                      {{establecimiento.nombre}}
                      <template v-for="(grupo,g) in establecimiento.grupoExplotacionList">
                        <v-icon right x-small class="mr-1" color="brown" :key="`${establecimiento.idEstablecimiento}${establecimiento.nombre}${g}agro`" v-if="grupo.icon === 'cow'">{{cowIcon}}</v-icon>
                        <v-icon right x-small class="mr-1" color="primary" :key="`${establecimiento.idEstablecimiento}${establecimiento.nombre}${g}gana`" v-else>{{grupo.icon}}</v-icon>
                        <span :key="`${establecimiento.idEstablecimiento}${establecimiento.nombre}${g}`" class="grey--text mr-2">{{grupo.nombre}}</span>
                      </template>
                    </v-list-item-title>

                    <v-list-item-title class="hidden-md-and-up">{{ establecimiento.nombre}}</v-list-item-title>
                    <v-list-item-subtitle class="hidden-md-and-up">
                      <template v-for="(grupo,g) in establecimiento.grupoExplotacionList">
                        <v-icon left x-small color="primary" :key="`${establecimiento.idEstablecimiento}${establecimiento.nombre}${g}gana`" v-if="grupo.icon !== 'cow'">{{grupo.icon}}</v-icon>
                        <v-icon left x-small color="brown" :key="`${establecimiento.idEstablecimiento}${establecimiento.nombre}${g}agro`" v-else>{{cowIcon}}</v-icon>
                        <span :key="`${establecimiento.idEstablecimiento}${establecimiento.nombre}${g}`" class="grey--text mr-2">{{grupo.nombre}}</span>
                      </template>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="ml-0">
                    <v-icon small>fa-arrow-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
                </template>
              </v-list-item-group>
            </v-list-group>

            <!-- Agricultor con UN on NINGUN establecimiento -->
            <v-list-item-group v-else :key="agricultor.agricultor.nombre">
              <v-list-item class="mb-0"
                @click="handleElegirAgricultor(agricultor.agricultor.idAgricultor,agricultor.establecimientoList[0])"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon small>fa-user</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ agricultor.agricultor.nombre}}</v-list-item-title>
                  <v-list-item-subtitle v-if="agricultor.establecimientoList.length === 1">
                    <span class="grey--text">{{agricultor.establecimientoList[0].nombre}}</span>
                    <template v-for="(grupo,g) in agricultor.establecimientoList[0].grupoExplotacionList">
                      <v-icon right x-small color="brown" :key="g" v-if="grupo.icon === 'cow'">{{cowIcon}}</v-icon>
                      <v-icon right x-small color="primary" :key="g" v-else>{{grupo.icon}}</v-icon>
                    </template>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action class="ml-0">
                  <v-icon small>fa-arrow-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>

            <v-divider
              v-if="i < searchFilteredAgricultorList.length - 1"
              :key="i"
            ></v-divider>
          </template>
        </v-list>
      </v-card-text>
    </fh-card>
  </fh-container>
</template>

<script>
  import FhContainer from '@/components/FhContainer'
  import FhCard from '@/components/FhCard'
  import {mapActions, mapGetters, mapState} from 'vuex'
  import { mdiCow } from '@mdi/js'

  export default {
    name: 'ElegirAgricultor',
    components: {FhCard, FhContainer},
    data() {
      return {
        disabled: false,
        search: '',
        filteredLength: 5,
        itemsPerPage: -1,
        selectedItem: [],
        cowIcon: mdiCow,
        dialog: false,
      }
    },
    computed: {
      ...mapState('agricultor', [
        'agricultorList',
        'listaGrupoExplotacion'
      ]),
      ...mapGetters('agricultor', [
        'isAgricultorSet'
      ]),
      ...mapState('admin', [
        'esAdmin',
      ]),
      ...mapState('zonas', [
        'listaZona',
      ]),
      searchFilteredAgricultorList() {
        return this.agricultorList.filter(agricultor => agricultor.agricultor.nombre.toLowerCase().includes(this.search.toLowerCase()))
      },
      showSearchField() {
        return this.agricultorList.length >= this.filteredLength
      },
    },
    methods: {
      ...mapActions('agricultor', [
        'setAgricultor',
        'fetchAgricultorList',
        'fetchListaGrupoExplotacion'
      ]),
      ...mapActions('zonas',[
        'fetchListaZona'
      ]),
      ...mapActions('snackbar', [
        'showSnackbar'
      ]),
      expandList(i){
        this.$set(this.selectedItem,i,!this.selectedItem[i])
      },
      async handleElegirAgricultor(id,establecimiento = null) {
        try {
          if (!this.disabled) {
            this.disabled = true
            let payload = {idAgricultor: id, establecimiento: establecimiento}
            await this.setAgricultor(payload)
            if(establecimiento && establecimiento.hasAgro){
              this.$router.push({name: 'AgroHome'}).then().catch((e)=>{})
            }else{
              this.$router.push({name: 'GanaderiaHome'}).then().catch((e)=>{})
            }
          }
        } catch (e) {
          this.disabled = false
        }
      },
    },
    async created () {
      try {
        await this.fetchAgricultorList()
        if (this.isAgricultorSet) {
          this.$router.push({ name: 'AgroHome' }).then().catch((e)=>{})
        }

        for (let index = 0; index < this.agricultorList.length; index++) {
          this.selectedItem[index] = false
        }
      } catch (e) {}
    }
  }
</script>

<style scoped>
  .fh-pointer {
    cursor: pointer;
  }
</style>
